<template>
  <validation-provider
    v-slot="{ errors }"
    :name="name"
    :rules="rules"
    :custom-messages="customMessages"
  >
    <b-field
      v-model="value"
      :type="{ 'is-danger': errors.length }"
      :message="errors + [ '&nbsp;' ]"
      :label="label"
      class="modern-field"
    >
      <slot
        :value="value"
        :onChange="onValueChange"
      >
        <b-input
          v-model="value"
          :disabled="disabled"
          @input="onValueChange"
        />
      </slot>
    </b-field>
  </validation-provider>
</template>

<script>
export default {
  name: 'ModernField',
  props: {
    name: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Label',
    },
    rules: {
      default: '',
    },
    customMessages: {
      default: null,
    },
    value: {
      default: null,
    },
    disabled: {
      default: false,
    },
  },
  methods: {
    onValueChange(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>

<style lang="stylus">
.modern-field .select,
.modern-field select
  width 100%

.modern-field label
  color #8A9499
</style>

<style scoped lang="stylus">
</style>
